import { createContext } from 'react';

const InstaReportContext = createContext();

export default InstaReportContext;
